import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Field/styles.module.css';

const FieldRow = (props?: any) => (
  <div {...props} className={styles.fieldRow} />
);

(FieldRow as any).displayName = 'FieldRow';

(FieldRow as any).propTypes = {
  /**
    * What to render inside the FieldRow
    */
  children: PropTypes.node.isRequired,
};

(FieldRow as any).defaultProps = {
};

export default FieldRow;
